var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { attr, belongsTo, hasMany } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import { alias } from '@ember/object/computed';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { CATEGORY_TYPE } from '@square/dashboard-items-data/models/connect/category/data';
export const MAX_ITEM_COUNT_IN_CATEGORY = 1000;
let Category = (_dec = attr('string', {
  protoEnum: CatalogObjectTypeProto,
  defaultValue: CatalogObjectType.CATEGORY
}), _dec2 = fragment('connect/category/data'), _dec3 = belongsTo('connect/category', {
  async: false,
  inverse: null
}), _dec4 = hasMany('connect/image', {
  async: false
}), _dec5 = hasMany('connect/availability-period'), _dec6 = alias('categoryData.name'), _dec7 = alias('categoryData.ordinal'), _dec8 = alias('categoryData.abbreviation'), _dec9 = alias('categoryData.labelColor'), _dec10 = alias('categoryData.categoryType'), _dec11 = alias('categoryData.isTopLevel'), _dec12 = alias('categoryData.onlineVisibility'), _dec13 = alias('categoryData.channels'), _dec14 = alias('categoryData.ecomSeoData'), _dec15 = alias('categoryData.locationOverrides'), _dec16 = hasMany('connect/category/path-to-root-category', {
  async: false
}), _dec17 = alias('categoryData.openGraphData'), _dec18 = alias('categoryData.itemCount'), _dec19 = alias('categoryData.categoryCount'), _dec20 = alias('categoryData.rootCategory'), (_class = (_class2 = class Category extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "categoryData", _descriptor2, this);
    _initializerDefineProperty(this, "parentCategory", _descriptor3, this);
    _initializerDefineProperty(this, "images", _descriptor4, this);
    _initializerDefineProperty(this, "availabilityPeriods", _descriptor5, this);
    _initializerDefineProperty(this, "name", _descriptor6, this);
    _initializerDefineProperty(this, "ordinal", _descriptor7, this);
    _initializerDefineProperty(this, "abbreviation", _descriptor8, this);
    _initializerDefineProperty(this, "labelColor", _descriptor9, this);
    _initializerDefineProperty(this, "categoryType", _descriptor10, this);
    _initializerDefineProperty(this, "isTopLevel", _descriptor11, this);
    // A categories onlineVisibility can be false even if its channels array is populated
    _initializerDefineProperty(this, "onlineVisibility", _descriptor12, this);
    _initializerDefineProperty(this, "channels", _descriptor13, this);
    _initializerDefineProperty(this, "ecomSeoData", _descriptor14, this);
    _initializerDefineProperty(this, "locationOverrides", _descriptor15, this);
    // The path-to-root should be a fragment array of the category data
    // but there is a bug in fragment array, see slack thread: https://square.slack.com/archives/C0254AEKX/p1708465676120269?thread_ts=1707149446.959249&cid=C0254AEKX
    // I have to convert the path-to-root-category to a model as a workaround
    _initializerDefineProperty(this, "pathToRoot", _descriptor16, this);
    _initializerDefineProperty(this, "openGraphData", _descriptor17, this);
    _initializerDefineProperty(this, "itemCount", _descriptor18, this);
    _initializerDefineProperty(this, "subCategoryCount", _descriptor19, this);
    _initializerDefineProperty(this, "rootCategory", _descriptor20, this);
  }
  get primaryImage() {
    return this.images.firstObject;
  }
  get hasChannels() {
    if (!this.channels) {
      return false;
    }
    return this.channels?.toArray().length > 0;
  }
  get categoryIdsInPathToRoot() {
    return new Set(this.pathToRoot?.map(pathToRootCategory => pathToRootCategory.id) ?? []);
  }
  get migratedFromSquareOnline() {
    return this.categoryData.migratedFromSquareOnline ?? false;
  }
  get isTopLevelMenuCategory() {
    return this.isTopLevel && this.categoryType === CATEGORY_TYPE.MENU_CATEGORY;
  }
  isInPathToRoot(categoryId) {
    return this.categoryIdsInPathToRoot.has(categoryId);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/category'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "categoryData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "parentCategory", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "images", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "availabilityPeriods", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "abbreviation", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "labelColor", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "categoryType", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isTopLevel", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "onlineVisibility", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "channels", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "ecomSeoData", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "locationOverrides", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "pathToRoot", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "openGraphData", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "itemCount", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "subCategoryCount", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "rootCategory", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { Category as default };